import axios from "axios";
import BootStrapDialog from "./BootStrapDialog";
import BootstrapDialogTitle from "./BootstrapDialogTitle";
import { Checkbox, CircularProgress, DialogActions, DialogContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import EmployeeTile from "./EmployeeTile";
import Button from "@mui/material/Button";
import secureLocalStorage from "react-secure-storage";

const SelectRecipient = (props) => {
    const { open, onClose, confirm, selectedEmployees, onChange } = props;
    const settings = secureLocalStorage.getItem("systemSettings");
    const settingsInfo = JSON.parse(settings);
    const mainBackground = settingsInfo?.mainBackground;

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [category, setCategory] = useState("All");
    const [checked, setChecked] = useState(selectedEmployees ?? []);
    const [search, setSearch] = useState("");

    const trim = search?.trim()?.toLowerCase();
    const listByCategory = category !== "All" ? list?.filter((item) => item.category === category) : list;
    const newList = trim
        ? listByCategory?.filter(
              (v) => v.email?.toLowerCase()?.includes(trim) || v.names?.toLowerCase()?.includes(trim)
          )
        : listByCategory;

    useEffect(() => {
        setChecked(selectedEmployees ?? []);
    }, [selectedEmployees]);

    const handleToggle = (value) => {
        if (typeof onChange === "function") {
            onChange(value);
        }
        const currentIndex = checked.findIndex((el) => el.id === value.id);
        const newChecked = checked.filter((v) => v.id !== value.id);
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const onCheckAll = () => {
        if (checked.length !== newList?.length) {
            setChecked(newList);
        } else {
            setChecked([]);
        }
    };

    useEffect(() => {
        if (open) {
            const fetchEmployees = async () => {
                setLoading(true);
                try {
                    const response = await axios.get("/api/resource/listAll");
                    setList(response.data.data); 
                } catch (error) {
                } finally {
                    setLoading(false);
                }
            };
            fetchEmployees();
        }
    }, [open]);

    const select = () => {
        onClose();
        confirm(checked);
    };

    return (
        <div>
            <BootStrapDialog open={open} fullWidth={true} maxWidth={"sm"} onClose={onClose}>
                <BootstrapDialogTitle id={"employee-selector"} onClose={onClose}>
                    Select Employee
                </BootstrapDialogTitle>
                <DialogContent>
                    {loading ? (
                        <div className={"text-center p-5"}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <div>
                            <div className={"mb-3"}>
                            </div>
                            <div className={"flex"}>
                                <div className={"flex-grow mr-3"}>
                                    <input
                                        type={"search"}
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        className={
                                            "px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        }
                                        placeholder={"Search here ....."}
                                    />
                                </div>
                                <span>
                                    <Checkbox
                                        edge="start"
                                        tabIndex={-1}
                                        checked={checked?.length === newList?.length}
                                        onChange={() => {
                                            onCheckAll();
                                        }}
                                        disableRipple
                                    />
                                </span>
                            </div>
                            {newList?.map((v) => {
                                return (
                                    <EmployeeTile
                                        key={v.id}
                                        employee={v}
                                        selected={checked?.findIndex((el) => el.id === v.id) !== -1}
                                        handleToggle={handleToggle}
                                    />
                                );
                            })}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button color={"error"} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        color={"success"}
                        onClick={() => select()}
                        // style={{ backgroundColor: settings?.backgroundColorPrimary }}
                        sx={{
                            backgroundColor:mainBackground,
                        }}
                        variant={"contained"}
                    >
                        Add Recipient
                    </Button>
                </DialogActions>
            </BootStrapDialog>
        </div>
    );
};

export default SelectRecipient;